export default "__VITE_ASSET__iK2LKIiz__"